import { api } from "@/api";
export const orderTemplateStore = {
  state: {
    orderTemplates: []
  },
  getters: {
    getOrderTemplates(state) {
      return state.orderTemplates;
    }
  },
  mutations: {
    setOrderTemplate(state, payload) {
      state.orderTemplates = payload;
    },
    addOrderTemplate(state, payload) {
      state.orderTemplates = state.orderTemplates.push(payload);
    }
  },
  actions: {
    async loadOrderTemplates(context) {
      const res = await api.getOrderTemplates();
      if (res) {
        context.commit("setOrderTemplate", res);
      }
    },
    async addOrderTemplate(context, payload) {
      const res = await api.postOrderTemplate(payload);
      if (res) {
        context.commit("addOrderTemplate", res);
        return res;
      }
    }
  }
};
